import React from 'react'

const Abnormalboth =(props)=>{
    let title = props.title
    return(
        <div className={`bgC-white wid-admin-s hig-ss margr-xxxs br-20 shadow-s-noHover fx-d-c fx-fsfs font-xs of-hid`} key={props.index}>
            <div className="fx-d-c fx-cc bgC-alert-EE hig-3 wid-admin-s">
                {/* <div className="fx-d-r wid-admin-s fx-cspar">
                    <div>{title[3][0]}</div>
                    <div>{title[3][1]}</div>
                </div> */}
                <div className="font-ml">
                    {title.name}                                        
                </div>
            </div>
            <div className="fx-d-c fx-cc hig-13 wid-admin-s">
                <div className="fx-d-c">
                    {"訊號過低 : " + title.rssi_count}
                </div>
                <div className="fx-d-c">
                    {"斷線 : " + title.offline_count}
                </div>
            </div>
        </div>
    );	

}



export const Abnormaldiscon =(props)=>{
    let title = props.title
    return(
        <div className={`bgC-white wid-admin-s hig-ss margr-xxxs br-20 shadow-s-noHover fx-d-c fx-fsfs font-xs of-hid`} key={props.index}>
            <div className="fx-d-c fx-cc bgC-alert-E hig-3 wid-admin-s">
                {/* <div className="fx-d-r wid-admin-s fx-cspar">
                    <div>{title[3][0]}</div>
                    <div>{title[3][1]}</div>
                </div> */}
                <div className="font-ml">
                    {title.name}                                        
                </div>
            </div>
            <div className="fx-d-c fx-cc wid-admin-s hig-13">
                {"斷線 : " + title.offline_count}
            </div>
        </div>
    );	

}




export const Abnormalsignal =(props)=>{
    let title = props.title
    return(
        <div className={`bgC-white wid-admin-s hig-ss margr-xxxs br-20 shadow-s-noHover fx-d-c fx-fsfs font-xs of-hid`} key={props.index}>
            <div className="fx-d-c fx-cc hig-3 bgC wid-admin-s">
                {/* <div className="fx-d-r wid-admin-s fx-cspar">
                    <div>{title[3][0]}</div>
                    <div>{title[3][1]}</div>
                </div> */}
                <div className="font-nl">
                    {title.name }                                        
                </div>
            </div>
            <div className="fx-d-c wid-admin-s hig-13 fx-cc">
                {"訊號過低 : " + title.rssi_count}
            </div>
        </div>
    );	

}
export default Abnormalboth;